import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export type PhotoInstructionData = {
  id: string;
  instruction: string;
  isRequired: boolean;
};

export type LocationSalesPreferencesData = {
  defaultWeightDisplayUnit: string;
  defaultPort: string;
  enableDefaultPrinting: boolean;
  skipScalePayment: boolean;
  askForDeletionConfirmation: boolean;
  photoInstructions: PhotoInstructionData[];
};

const mockData: LocationSalesPreferencesData = {
  defaultWeightDisplayUnit: 'PRICE_UNIT',
  defaultPort: 'JOAQB',
  enableDefaultPrinting: true,
  skipScalePayment: true,
  askForDeletionConfirmation: true,
  photoInstructions: [
    { id: '1', instruction: 'Empty container', isRequired: true },
    { id: '2', instruction: '1 / 4 loaded', isRequired: true },
    { id: '3', instruction: 'Half loaded', isRequired: true },
  ],
};

// TODO: Replace mock with actual query when backend implements it
// Expected GraphQL query:
// (params: { facilityId: string }) => ({
//   facilitySalesPreferences: {
//     __args: { facilityId: params.facilityId },
//     defaultWeightDisplayUnit: true,
//     defaultPort: true,
//     enableDefaultPrinting: true,
//     skipScalePayment: true,
//     askForDeletionConfirmation: true,
//     photoInstructions: {
//       id: true,
//       instruction: true,
//       isRequired: true,
//     },
//   },
// })

export const locationSalesPreferencesQueryAtom = createQueryAtomFactory(
  'settings.locationSalesPreferences',
  // Placeholder selection - will be replaced when BE implements the query
  (_params: { facilityId: string }) => ({
    facility: {
      __args: {
        id: _params.facilityId,
      },
      id: true,
      // salesPreferences: {
      //   __args: {
      //     facilityId: _params.facilityId,
      //   },
      //   defaultWeightDisplayUnit: true,
      //   defaultPort: true,
      //   enableDefaultPrinting: true,
      //   skipScalePayment: true,
      //   askForDeletionConfirmation: true,
      //   photoInstructions: {
      //     id: true,
      //     instruction: true,
      //     isRequired: true,
      //   },
      // },
    },
  }),
  {
    select: (): LocationSalesPreferencesData => mockData,
  },
);
